export default __webpack_public_path__ + "1d9d5bce566c85fa242cb21ad3292cb8.webp";